module.exports = __webpack_public_path__ + "img/3.9c67c101.jpg";